import FingerprintOutlinedIcon from '@mui/icons-material/FingerprintOutlined';
import { Button, Stack, Typography } from '@mui/material';
import Link from 'next/link';
import MobileAppBar from '../components/MobileAppBar';
import AuthContainer from '../components/AuthContainer';
import NeedHelp from './NeedHelp';
import { IconSvg } from '@/components/Icon';
import { EXTERNAL_LINKS } from '@/utils/constants';
type Props = {
  back: () => void;
  message?: string;
};
const NoSejamInfo = (props: Props) => {
  return <>
      <MobileAppBar title='اطلاعات سجام' sx={{
      display: {
        md: 'none',
        xs: 'initial'
      }
    }} backTo={props.back} data-sentry-element="MobileAppBar" data-sentry-source-file="NoSejamInfo.tsx" />
      <AuthContainer data-sentry-element="AuthContainer" data-sentry-source-file="NoSejamInfo.tsx">
        <Stack alignItems='center' sx={{
        mb: 'var(--spacing_xl)',
        fontSize: {
          xs: 72,
          md: 100
        }
      }} data-sentry-element="Stack" data-sentry-source-file="NoSejamInfo.tsx">
          <IconSvg component='NotVerified' data-sentry-element="IconSvg" data-sentry-source-file="NoSejamInfo.tsx" />
        </Stack>

        <Stack width='100%' gap='var(--spacing_l)' data-sentry-element="Stack" data-sentry-source-file="NoSejamInfo.tsx">
          <Typography typography='bodyRegular__Wallfund' data-sentry-element="Typography" data-sentry-source-file="NoSejamInfo.tsx">
            {props.message ?? <>
                برای استفاده از خدمات زیما باید در{' '}
                <Typography title={EXTERNAL_LINKS.sejam.href} component='strong' typography='bodyStrong__Wallfund'>
                  سامانه سجام
                </Typography>{' '}
                ثبت‌نام کنید. جهت کسب اطلاعات بیشتر به وب‌سایت این سامانه مراجعه
                کنید.
              </>}
          </Typography>
          <Button component={Link} href={EXTERNAL_LINKS.sejam.href} variant='ghost' size='large' startIcon={<FingerprintOutlinedIcon />} prefetch={false} fullWidth data-sentry-element="Button" data-sentry-source-file="NoSejamInfo.tsx">
            مراجعه به سامانه سجام
          </Button>

          <NeedHelp data-sentry-element="NeedHelp" data-sentry-source-file="NoSejamInfo.tsx" />
        </Stack>
      </AuthContainer>
    </>;
};
export default NoSejamInfo;